module.exports = __webpack_public_path__ + "img/1.bfd97428.svg";